import React from "react";
import { BundleInterface } from "../../../../store/mine_craft/bundlesSlice";
import Card from "../../../../componets/Card";

const _Details = ({ bundle }: { bundle: BundleInterface | undefined }) => {
  if (!bundle) {
    return null;
  }

  return (
    <>
      <Card className='v-mb-20'>
      </Card>
    </>
  );
}

export default _Details;
